import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import 'iconify-icon';

const LANGS = [
  { code: 'pt', label: 'PT', flag: '🇧🇷', name: 'Português' },
  { code: 'en', label: 'EN', flag: '🇺🇸', name: 'English' },
  { code: 'es', label: 'ES', flag: '🇪🇸', name: 'Español' },
];

const LanguageSwitcher = ({ variant = 'default' }) => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label={t('lang.switch')}
        aria-expanded={open}
        data-testid="language-switcher-trigger"
        className="flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-mono uppercase tracking-widest text-neutral-500 hover:text-accent-orange transition-colors accent-focus"
      >
        <span className="text-base leading-none" aria-hidden="true">{current.flag}</span>
        <span>{current.label}</span>
        <iconify-icon icon="solar:alt-arrow-down-linear" className={`text-sm transition-transform ${open ? 'rotate-180' : ''}`}></iconify-icon>
      </button>
      {open && (
        <div
          className="absolute right-0 top-full mt-2 min-w-[160px] bg-white border border-neutral-200 rounded-lg shadow-xl overflow-hidden z-50 animate-in fade-in slide-in-from-top-2 duration-200"
          role="menu"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => change(l.code)}
              data-testid={`language-option-${l.code}`}
              role="menuitem"
              className={`w-full px-4 py-2.5 flex items-center gap-3 text-sm text-left transition-colors ${
                l.code === current.code
                  ? 'bg-accent-orange/10 text-accent-orange font-medium'
                  : 'text-neutral-700 hover:bg-neutral-50 hover:text-accent-orange'
              }`}
            >
              <span className="text-lg leading-none" aria-hidden="true">{l.flag}</span>
              <span className="flex-1">{l.name}</span>
              {l.code === current.code && (
                <iconify-icon icon="solar:check-circle-bold" className="text-base"></iconify-icon>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
